import { render, staticRenderFns } from "./legalDeclaration.vue?vue&type=template&id=9e4f8cd2&scoped=true"
import script from "./legalDeclaration.vue?vue&type=script&lang=js"
export * from "./legalDeclaration.vue?vue&type=script&lang=js"
import style0 from "./legalDeclaration.vue?vue&type=style&index=0&id=9e4f8cd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4f8cd2",
  null
  
)

export default component.exports